<template>
  <div class="container">
    <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Refinación y distribución</h1>
      <hr>
      
    </div>
    
    <div>
        
      <dai-tarjeta-contenedor-mapa :permitir-colapso="false" 
      class="mapa-administracion-hidrocarburos">
      <dai-mapa
      :zoom="5" 
      :centro="[-97.467,21.927]"
      >
          
        <dai-capa-xyz id="Mapa" :visible="capa_prendida==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>
        
        <dai-capa-xyz id="Satélite" :visible="capa_prendida==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>



        <dai-capa-geojson 
        id="infra_ductos_petroliferos"
        titulo="Ductos petrolíferos"
        :zoom-al-dar-click="false"
        :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.nom_ducto}<br><b>Servicio:</b> ${feat.servicio}<br><b>Longitud:</b> ${feat.longitud}<br><b>Diámetro:</b> ${feat.diametro}`"
        url="../geodata/hidrocarburos/infra_ductos_petroliferos.geojson"
        
        :reglas-estilo-capa="{
        clasificacion:'categorias',
        columna : 'servicio',
        acomodoCategorias: ['Poliducto','Combustóleo-ducto','Diésel-ducto','Magna-ducto','Premium-ducto','Turbosino-ducto'],
        propiedadObjetivo: 'relleno',
        colores:['#cccccc','#666666','#000000','#0e930e','#ff0000','#555555'],
        clases:5,
        tituloVariable:'Capacidad nominal'
        }"
        :estilo-capa="{
        stroke:{width:2}
        }"
        />

        <dai-capa-geojson 
        id="intra_refinernias"
        titulo="Refinerias"
        :zoom-al-dar-click="false"
        :contenidoPopup="(feat)=>`<b>Refinería:</b> ${feat.refineria}<br><b>Nombre oficial:</b> ${feat.nombre_ref}<br><b>Estado:</b> ${feat.estado}<br><b>Año inicio:</b> ${feat.inaguracio}<br><b>Capacidad:</b> ${feat.capacidad} MBD`"
        url="../geodata/hidrocarburos/infra_refinerias.geojson"
        :reglas-estilo-capa="[{
        clasificacion:'linear',
        columna : 'capacidad',
        acomodoCategorias: [215,253,291,330],
        propiedadObjetivo: 'proporcion',
        proporciones:[4,6,8,10],
        clases:4,
        tituloVariable:'Capacidad'
        }]"
        :estilo-capa="{
              circle:{
                  stroke:{color:'black',width:1},
                  radius:1,
                  fill:{color:'red'}
              }
          }"
        />
        
        

        <dai-capa-geojson 
        id="intra_tar"
        titulo="Terminales de almacenamiento"
        :zoom-al-dar-click="false"
        :contenidoPopup="(feat)=>`<b>Nombre:</b> ${feat.nombre}<br><b>Capacidad de operación:</b> ${feat.cap_operar} barriles<br><b>Medio:</b> ${feat.medio_de_s}`"
        url="../geodata/hidrocarburos/infra_tar.geojson"
        :reglas-estilo-capa="[{
        clasificacion:'linear',
        columna : 'cap_operar',
        acomodoCategorias: [50,100,150,200,250],
        propiedadObjetivo: 'proporcion',
        proporciones:[2,4,6,8,10],
        clases:5,
        tituloVariable:'Capacidad'
        }]"
        :estilo-capa="{
              circle:{
                  stroke:{color:'black',width:1},
                  radius:1,
                  fill:{color:'blue'}
              }
          }"
        />

        </dai-mapa>
        <template v-slot:header>

           
            <h2 v-width-control="'100%'">Infraestructura de refinación y distribución de Pemex</h2>
            
            <p class="texto-secundario" v-width-control="'50%'">Capacidad de almacenamiento en barriles. Datos actualizados a 2019.</p>

            <dai-interruptor-mapa v-width-control="'50%'"
              v-model="capa_prendida"
              :opciones="['Mapa','Satélite']"
              /> 
              <br/>

            <dai-leyenda-mapa v-width-control="'100%'"
            titulo="Ductos petrolíferos"
            :para="['infra_ductos_petroliferos']"
            />
            <dai-leyenda-mapa v-width-control="'50%'"
            titulo="Refinerías"
            :para="['intra_refinernias']"
            />
            <dai-leyenda-mapa v-width-control="'50%'"
            titulo="Terminales de almacenamiento"
            :para="['intra_tar']"
            />
        </template>

      </dai-tarjeta-contenedor-mapa>

      <br>

      <dai-tarjeta-contenedor-mapa :colapsada="false" class="mapa-consumo">

        <dai-mapa :zoom="5" :centro="[-97.467,21.927]">
            
            <dai-capa-xyz id="Mapa" :visible="capa_prendida2==='Mapa'" url="https://{a-c}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"/>
        
            <dai-capa-xyz id="Satélite" :visible="capa_prendida2==='Satélite'" url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png"/>

            
            <dai-capa-geojson 
            id="gasolineras_activas"
            titulo="Gasolinerías"
            :zoom-al-dar-click="false"
            :contenidoPopup="(feat)=>`<b>Municipio:</b> ${feat.nomgeo}<br><b>Número gasolinerías:</b> ${feat.count}`"
            url="../geodata/hidrocarburos/gasolineras_activas.geojson?v=0.0.1"
            :reglas-estilo-capa="[{
            clasificacion:'linear',
            columna : 'count',
            acomodoCategorias: [50,100,150,200,250],
            propiedadObjetivo: 'proporcion',
            proporciones:[2,4,6,8,10],
            clases:5,
            tituloVariable:'Número de gasolinerías por municipio'
            }]"
            :estilo-capa="{
                  circle:{
                      stroke:{color:'white',width:1},
                      radius:1,
                      fill:{color:'red'}
                  }
              }"
            />

          </dai-mapa>
        <template v-slot:header>

            <h2 v-width-control="'100%'">Red de gasolineras existentes por municipio</h2> 
            
            <p v-width-control="'50%'" class="texto-secundario">Datos actualizados a 2019.</p>

            <dai-interruptor-mapa v-width-control="'50%'"
              v-model="capa_prendida2"
              :opciones="['Mapa','Satélite']"
              /> 
              <br/>

            <dai-leyenda-mapa
            titulo="Estaciones de servicio"
            :para="['gasolineras_activas']"
            />
        </template>

        
      </dai-tarjeta-contenedor-mapa>


        

    </div>

    <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
      <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
      <ul class="lista-referencias">
          <li><em><strong>Comisión Nacional de Hidrocarburos (CNH) (2023).</strong></em> Centro Nacional de Información de Hidrocarburos. Mapa de Hidrocarburos. Recuperado en enero de 2023 <a href="https://mapa.hidrocarburos.gob.mx/" target="_blank">https://mapa.hidrocarburos.gob.mx/</a></li>
      </ul>
    </div>

  </div>
</template>

<script>

export default {
          data:function(){
              return {
                  capa_prendida:'Mapa',
                  capa_prendida2:'Mapa',
              }
          }
          
      }

</script>


<style lang="scss">

  .legend-normal-vector
  {
    float: left !important;
    margin-left: 1em !important;
  }

  .mapa-administracion-hidrocarburos .dai-map-container
  {
      height: 60vh !important;
  }
</style>


